<script setup lang="ts">
import { RouterView } from 'vue-router'
</script>

<template>
  <div class="flex flex-col w-full bg-background text-text-primary">
    <RouterView />
  </div>
</template>
